import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'me-modal-column',
  styleUrl: 'me-modal-column.scss',
  shadow: false,
})
export class MeModalColumn {

  render() {
    return (
      <Host class="me-modal-column">
        <slot></slot>
      </Host>
    );
  }

}
